export const requestOptions = (data) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(data),
})
const url = 'https://cf-durable-obj-esm.ookb.workers.dev/color-sort'
// const url2 = 'http://127.0.0.1:8787/color-sort'

export function post(data) {
  return fetch(url, requestOptions(data))
    .then((response) => response.json())
    // .then((data) => this.setState({ postId: data.id }))
}
export function getIds(colorId, defaultIds = []) {
  const getIdsUrl = `${url}/${colorId}`
  console.log('getIds', getIdsUrl)
  return fetch(getIdsUrl)
    .then((response) => response.json())
    .then((res) => (res || defaultIds))
}
